import { tagIndex } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const levelStyles: Record<number, string> = {
  3: "bg-primary-100 text-primary-700 text-base px-4 py-2",
  2: "bg-secondary-100 text-secondary-900 text-sm px-3.5 py-1.5",
  1: "border border-background-300 text-foreground-700 text-xs px-3 py-1",
};

export default function TagIndex() {
  return (
    <section id="tags" className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="标签索引"
        title="用标签横向串联，关键词一搜直达"
        desc="标签把不同专题里的同类条目连成一条线，想找某类内容时不用逐个专题翻，按标签跳转路径更短。"
        linkLabel="查看完整标签表"
        linkHref="#sources"
      />

      <div className="flex flex-wrap items-center gap-2.5 md:gap-3">
        {tagIndex.map((tag) => (
          <a
            key={tag.name}
            href="#collections"
            className={`group inline-flex items-center gap-2 rounded-full transition-colors hover:opacity-85 cursor-pointer whitespace-nowrap ${
              levelStyles[tag.level] ?? levelStyles[1]
            }`}
          >
            <i className="ri-hashtag text-current opacity-60" />
            {tag.name}
            <span className="font-label text-[11px] opacity-65">{tag.count}</span>
          </a>
        ))}
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 rounded-xl border border-background-200/80 bg-background-100/60 p-4 sm:grid-cols-3 md:p-5">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-search-eye-line text-lg" />
          </span>
          <div>
            <p className="text-sm font-medium text-foreground-950">关键词直达</p>
            <p className="text-xs text-foreground-600">输入标签，直接落到对应条目</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
            <i className="ri-node-tree text-lg" />
          </span>
          <div>
            <p className="text-sm font-medium text-foreground-950">关联跳转</p>
            <p className="text-xs text-foreground-600">同标签内容自动串成一条线</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-500 text-background-50">
            <i className="ri-filter-3-line text-lg" />
          </span>
          <div>
            <p className="text-sm font-medium text-foreground-950">一键筛选</p>
            <p className="text-xs text-foreground-600">多标签叠加，范围越缩越准</p>
          </div>
        </div>
      </div>
    </section>
  );
}